import React from "react";
import groupeImg from "../../img/accueil_concept3.jpg";

function Groupes() {
  return (
    <div className="w-full bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-12 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="w-full h-full rounded-2xl overflow-hidden shadow-lg bg-orange-50 max-h-[500px]">
            <img
              src={groupeImg}
              alt="Atelier groupe Mood"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex flex-col gap-4">
            <p className="text-sm uppercase tracking-[0.3em] text-orange-500 font-semibold">
              Groupes
            </p>
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900">
              Moments créatifs à plusieurs
            </h1>
            <p className="text-slate-700 leading-relaxed">
              Envie de marquer une occasion ou simplement de vivre un moment créatif en
              groupe ? Mood Café Céramique conçoit des ateliers sur mesure pour
              anniversaires, EVJF/EVG, sorties d’équipe ou réunions entre amis.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Vous créez vos pièces en céramique dans un espace chaleureux, avec boissons
              et encas disponibles sur place. La réservation en ligne est ouverte pour des
              groupes jusqu’à 8 personnes. Pour organiser plus grand ou définir un format
              particulier, contactez-nous à{" "}
              <a
                href="mailto:contact@mood-cafe-atelier.com"
                className="text-orange-600 font-semibold hover:text-orange-700"
              >
                contact@mood-cafe-atelier.com
              </a>{" "}
              pour construire ensemble l’expérience qui vous convient.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Groupes;
